import { render, staticRenderFns } from "./vipSuc.vue?vue&type=template&id=47b9c30a&scoped=true"
import script from "./vipSuc.vue?vue&type=script&lang=js"
export * from "./vipSuc.vue?vue&type=script&lang=js"
import style0 from "./vipSuc.vue?vue&type=style&index=0&id=47b9c30a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b9c30a",
  null
  
)

export default component.exports